import classNames from 'classnames/bind';
import { useContext } from 'react';
import { useInfoParamsContext } from 'contexts/infoParams';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import { TripType, useSearchParamsContext } from 'contexts/searchParams';
import { ITabContent } from '..';
import {
  City,
  DepartureDate,
  Direct,
  Passenger,
  StayDuration,
  Swap,
} from '../select';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export default function RoundTrip({ clickCodePrefix }: ITabContent) {
  const setModal = useContext(ModalFuncContext);
  const { searchParams, isDomestic } = useSearchParamsContext();
  const { setInfoParamsFromCommon } = useInfoParamsContext();
  const { stayLength } = searchParams;
  const modalHandler = (type: Modal, index?: number) => () => {
    setInfoParamsFromCommon(searchParams);
    setModal({ type, payload: { index }, position: ModalPosition.MAIN });
  };

  return (
    <>
      <div className={cx('routes')}>
        <City
          className={cx('route')}
          departure
          index={0}
          clickCodePrefix={clickCodePrefix}
          onClick={modalHandler(Modal.DEPARTURES)}
        />
        <City
          className={cx('route')}
          index={0}
          clickCodePrefix={clickCodePrefix}
          onClick={modalHandler(Modal.ARRIVALS)}
        />
        <Swap
          className={cx('swap')}
          index={0}
          tripType={TripType.RT}
          clickCodePrefix={clickCodePrefix}
        />
      </div>
      <div className={cx('options')}>
        <DepartureDate
          className={cx('option')}
          index={0}
          clickCodePrefix={clickCodePrefix}
          onClick={modalHandler(Modal.CALENDAR, 0)}
        />
        {!isDomestic && !!stayLength ? (
          <StayDuration
            className={cx('option')}
            clickCodePrefix={clickCodePrefix}
            onClick={modalHandler(Modal.CALENDAR, 1)}
          />
        ) : (
          <DepartureDate
            className={cx('option')}
            index={1}
            clickCodePrefix={clickCodePrefix}
            onClick={modalHandler(Modal.CALENDAR, 1)}
          />
        )}
      </div>
      <div className={cx('options')}>
        <Passenger className={cx('option')} clickCodePrefix={clickCodePrefix} />
        <Direct
          className={cx('option', 'as_direct')}
          clickCodePrefix={clickCodePrefix}
        />
      </div>
    </>
  );
}
